import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import { SORT_DIRECTION } from '../../../util/cacUtils';
import GenericSHTableCellContent from './GenericSHTableCellContent';

const GenericSHTableView = props => {
  const handleScrollBarWidth = () => {
    /* istanbul ignore next */
    $.fn.getScrollWidth = () => {
      const $outer = $('<div>').css({ visibility: 'hidden', width: 100, overflow: 'scroll' }).appendTo('body');
      const widthWithScroll = $('<div>').css({ width: '100%' }).appendTo($outer).outerWidth();
      $outer.remove();
      return 100 - widthWithScroll;
    };
    /* istanbul ignore next */
    $.fn.hasVScrollBar = () => {
      if ($('.after-scroll-header-col').length !== 0) {
        $('.after-scroll-header-col').remove();
      }
      return $('#main-content-grid').get(0)
        ? $('#main-content-grid').get(0).scrollHeight >
            $('#main-content-grid').height()
        : false;
    };
    const hasScrollBar = $('#main-content-grid').hasVScrollBar();
    /* istanbul ignore next */
    if (hasScrollBar) {
      const scrollWidth = $().getScrollWidth();
      if ($('.after-scroll-header-col').length === 0) {
        $('.generic-sht-header').append(
          `<div class="after-scroll-header-col" 
          style="min-width:${scrollWidth}px;width:${scrollWidth}px;background-color:#${'2f445c'}">
           </div>`
        );
      }
    } else if ($('.after-scroll-header-col').length !== 0) {
      $('.after-scroll-header-col').remove();
    }
  };

  // DidMount Alternative
  useEffect(() => {
    setTimeout(() => {
      handleScrollBarWidth();
    }, 1000);
    window.addEventListener('resize', handleScrollBarWidth);
    // return a function for canceling subscriptions
    return window.removeEventListener('resize', handleScrollBarWidth);
  });

  const onCorrAxesTableViewSort = (key, columnIndex) => {
    let sortOrder = SORT_DIRECTION.DESC;
    if (
      props.sortColumnIndex === columnIndex &&
      props.sortKey === key
    ) {
      switch (props.sortOrder) {
        case SORT_DIRECTION.DESC:
          sortOrder = SORT_DIRECTION.ASC;
          break;
        case SORT_DIRECTION.ASC:
          sortOrder = SORT_DIRECTION.NONE;
          break;
        default:
          sortOrder = SORT_DIRECTION.DESC;
      }
    }
    const sortObj = { sortOrder, key, columnIndex };
    props.onSort(sortObj);
  };

  const {
    sortColumnIndex,
    sortKey,
    sortOrder,
    tableData,
    tableHeader,
    isCorrAxesTable,
  } = props;
  return (
    <div className="generic-sht">
      <div className="generic-sht-header">
        {tableHeader.map((item, columnIndex) => (
          <div key={uuid()} className="generic-sht-header-item">
            <Fragment>
              {columnIndex === 0 ? (
                <button
                  type="button"
                  id={`${item.key}-header${columnIndex}`}
                  style={{ textAlign: 'left', width: '100%' }}
                  className="generic-sht-header-item-value"
                >
                  {item.text}
                </button>
              ) : (
                <button
                  type="button"
                  id={`${item.key}-header${columnIndex}`}
                  onClick={() =>onCorrAxesTableViewSort(item.key, columnIndex)
                  }
                  style={{ textAlign: 'left', width: '100%' }}
                  className="generic-sht-header-item-value"
                >
                  {item.text}
                  {sortKey === item.key &&
                    sortOrder === 'desc' &&
                    sortColumnIndex === columnIndex && <span> ▼</span>}
                  {sortKey === item.key &&
                    sortOrder === 'asc' &&
                    sortColumnIndex === columnIndex && <span> ▲</span>}
                </button>
              )}
            </Fragment>
          </div>
        ))}
      </div>
      <div id="main-content-grid" className="generic-sht-content">
        {tableData &&
          tableData.length > 0 &&
          tableData.map((row, index) => (
            <GenericSHTableCellContent
              key={uuid()}
              data-test="genericSHTCellContentCompoent"
              rowData={row}
              index={index}
              isCorrAxesTable={isCorrAxesTable}
            />
          ))}
      </div>
    </div>
  );
};

GenericSHTableView.propTypes = {
  tableData: PropTypes.instanceOf(Array),
  tableHeader: PropTypes.instanceOf(Array),
  isCorrAxesTable: PropTypes.bool,
  sortColumnIndex: PropTypes.number,
  sortOrder: PropTypes.string,
  sortKey: PropTypes.string,
  onSort: PropTypes.func,
};

export default GenericSHTableView;
